/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sgrp_FoundationInputs */

const en_sgrp_foundation = /** @type {(inputs: Sgrp_FoundationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FOUNDATION`)
};

const ar_sgrp_foundation = /** @type {(inputs: Sgrp_FoundationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأساسيات`)
};

const bn_sgrp_foundation = /** @type {(inputs: Sgrp_FoundationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফাউন্ডেশন`)
};

const de_sgrp_foundation = /** @type {(inputs: Sgrp_FoundationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FOUNDATION`)
};

const es_sgrp_foundation = /** @type {(inputs: Sgrp_FoundationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FOUNDATION`)
};

const fr_sgrp_foundation = /** @type {(inputs: Sgrp_FoundationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FOUNDATION`)
};

const pt_sgrp_foundation = /** @type {(inputs: Sgrp_FoundationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FOUNDATION`)
};

const zh_sgrp_foundation = /** @type {(inputs: Sgrp_FoundationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FOUNDATION`)
};

const tr_sgrp_foundation = /** @type {(inputs: Sgrp_FoundationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FOUNDATION`)
};

const ru_sgrp_foundation = /** @type {(inputs: Sgrp_FoundationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FOUNDATION`)
};

const pl_sgrp_foundation = /** @type {(inputs: Sgrp_FoundationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FOUNDATION`)
};

/**
* | output |
* | --- |
* | "FOUNDATION" |
*
* @param {Sgrp_FoundationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const sgrp_foundation = /** @type {((inputs?: Sgrp_FoundationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sgrp_FoundationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_sgrp_foundation(inputs)
	if (locale === "bn") return bn_sgrp_foundation(inputs)
	if (locale === "de") return de_sgrp_foundation(inputs)
	if (locale === "es") return es_sgrp_foundation(inputs)
	if (locale === "fr") return fr_sgrp_foundation(inputs)
	if (locale === "pt") return pt_sgrp_foundation(inputs)
	if (locale === "zh") return zh_sgrp_foundation(inputs)
	if (locale === "tr") return tr_sgrp_foundation(inputs)
	if (locale === "ru") return ru_sgrp_foundation(inputs)
	if (locale === "pl") return pl_sgrp_foundation(inputs)
	return en_sgrp_foundation(inputs)
});